export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-plus-c86ef56c84e19d9d5f012ba6067e241d.svg";